import { render, staticRenderFns } from "./FormTaxpayerTypeLocale.vue?vue&type=template&id=a1245358&scoped=true&"
import script from "./FormTaxpayerTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormTaxpayerTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1245358",
  null
  
)

export default component.exports